var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "footer-copyright"
  }, [_c('div', {
    staticClass: "menu"
  }, [_vm._l((_vm.aboutusList), function(aboutus, index) {
    return [_c('a', {
      attrs: {
        "href": aboutus.url
      }
    }, [_vm._v(_vm._s(aboutus.title))]), _vm._v(" "), (index != (_vm.aboutusList.length - 1)) ? [_vm._v("|")] : _vm._e()]
  })], 2), _vm._v(" "), _vm._m(0)])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n\t\t\tCopyright © 2017 All Rights Reserved baomate.com\n\t\t\t"), _c('span', {
    attrs: {
      "id": "site_stat"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0307353a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterCopyright.vue
// module id = lo3H
// module chunks = 1